module.exports = __webpack_public_path__ + "media/svg-new/success2-22f58d2d.svg";